<template>
<div class="e2e-table"> 
    <table class="mc-table">
      <tr  v-for="(cells,rowIndex) in fragment.rows"
            :key="'row_'+rowIndex"
            style="margin: 2px 2px 2px 2px;">

          <div  v-for="(cell,cellIndex) in cells"
                :key="'cell_' + rowIndex+'_'+cellIndex"
                :is="cell.heading ? 'th' : 'td'"
                :colspan="cell.width"
                :rowspan="cell.height"
                style="margin: 2px 2px 2px 2px;">

                <div :fragment="cell.content" :is="resolveFragmentComponentName(cell.content)"/>

          </div>

      </tr>
    </table>
</div>
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-table",
  props: ["fragment"],
  computed: {},
  methods: {
    resolveFragmentComponentName
  }
};
</script>
 

<style scoped>
  table {
    width:100%;
  }
  table, th, td { 
    border: 1px solid black;
    border-collapse: collapse;
  }
  th, td {
    padding: 5px;
    text-align: left;
  }
  th {
    background-color: lightgray;
  }
</style>